import { Controller, useForm } from 'react-hook-form';
import {
  Button,
  Box,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  FormControl,
  FormGroup,
  Link as MUILink
} from '@mui/material';
import { Input, Select } from '../../../Common';
import { yupResolver } from '@hookform/resolvers/yup';
import IconTextField from '../../../Common/Input/IconTextField';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { coder } from '../../validationSchema';
import { Fragment, useEffect, useRef, useState } from 'react';
import './index.css';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/reducers';
import { signup } from '../../../../store/actions/register';
import ReCAPTCHA from 'react-google-recaptcha';
import {
  handleExpiredCaptcha,
  sitekey,
  toggleConfirmPasswordType,
  togglePasswordType
} from '../../registerUtill';

const BasicForm = ({ role, setIsOpen, setShowMessages }: any) => {
  const recaptchaRef = useRef(null);
  const dispatch = useDispatch();
  const naviagte = useNavigate();
  const userRegisterData = useSelector((state: RootState) => state?.register);
  const WEBSITE_URL = process.env.REACT_APP_WEBSITE_BASE_URL;

  const [passwordType, setPasswordType] = useState('password');
  const [confirmPasswordType, setConfirmPasswordType] = useState('password');
  const [clickedFlag, setClickedFlag] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    clearErrors,
    formState: { errors }
  } = useForm({ resolver: yupResolver(coder.basicForm) });

  useEffect(() => {
    if (clickedFlag) {
      if (userRegisterData && userRegisterData.error !== null) {
        setIsOpen(true);
      } else {
        !userRegisterData.loading && naviagte('/verification');
      }
    }
    setTimeout(() => {
      setShowMessages({ showSnackBar: false });
    }, 3000);
  }, [userRegisterData, clickedFlag]);

  const handleBasicForm = (data: any) => {
    const payload = {
      confirm_password: data.confirm_password,
      email: data.email,
      first_name: data.first_name,
      last_name: data.last_name,
      password: data.password,
      phone: data.phone,
      role,
      tc: data.tc,
      promotional_consent: data.newsLetter
    };

    dispatch(signup(payload));
    setClickedFlag(true);
  };

  const handleAgencyChange = (e: any) => {
    const value = e.target.value;
    if (value === 'AGENCY') {
      setIsOpen(true);
    }
  };

  return (
    <Fragment>
      <form onSubmit={handleSubmit(handleBasicForm)}>
        <Box>
          <Box className="form-field-wrapper">
            <Box className="name-wrapper">
              <Input
                type="text"
                id="first_name"
                name="first_name"
                label="First Name*"
                isRequired
                register={register}
                error={errors}
              />
            </Box>
            <Box className="name-wrapper">
              <Input
                type="text"
                id="last_name"
                name="last_name"
                label="Last Name*"
                isRequired
                register={register}
                error={errors}
              />
            </Box>
            <Box>
              <Input
                type="email"
                id="email"
                name="email"
                label="Email*"
                isRequired
                register={register}
                error={errors}
              />
            </Box>
            <Box>
              <IconTextField
                id="passowrd"
                name="password"
                label="Password*"
                type={passwordType}
                position="start"
                PrimaryIcon={VisibilityOff}
                SecondaryIcon={Visibility}
                iconPosition={['end']}
                register={register}
                error={errors}
                primaryIconAction={() => togglePasswordType(passwordType, setPasswordType)}
                secondaryIconAction={() => togglePasswordType(passwordType, setPasswordType)}
              />
            </Box>
            <Box>
              <IconTextField
                id="confirm_password"
                name="confirm_password"
                label="Confirm Password*"
                type={confirmPasswordType}
                position="start"
                PrimaryIcon={VisibilityOff}
                SecondaryIcon={Visibility}
                iconPosition={['end']}
                register={register}
                error={errors}
                primaryIconAction={() =>
                  toggleConfirmPasswordType(confirmPasswordType, setConfirmPasswordType)
                }
                secondaryIconAction={() =>
                  toggleConfirmPasswordType(confirmPasswordType, setConfirmPasswordType)
                }
              />
            </Box>
            <Box className="phone-select-wrapper">
              <Box width={'70%'}>
                <Select
                  id="countryCode"
                  name="countryCode"
                  label="Country Code*"
                  isRequired={true}
                  register={register}
                  error={errors}
                  options={[
                    { value: '+91', label: 'IND (+91)' },
                    { value: '+1', label: 'USA (+1)' }
                  ]}
                />
              </Box>
              <Input
                type="text"
                id="phone"
                name="phone"
                label="Phone*"
                isRequired
                register={register}
                error={errors}
                className="phone-field"
              />
              {/* for future use */}
              {/* <Select
                id="type"
                name="type"
                label="Type"
                isRequired={true}
                register={register}
                onChange={(e) => handleAgencyChange(e)}
                error={errors}
                options={[{ value: 'INDIVIDUAL', label: 'Individual' }]}
              /> */}
            </Box>
          </Box>

          <Box className="term-condition-wrapper">
            <FormControl required component="fieldset" variant="standard">
              <FormGroup>
                <FormControlLabel
                  key="tc"
                  control={
                    <Controller
                      name="tc"
                      control={control}
                      render={({ field }) => <Checkbox {...field} />}
                    />
                  }
                  label={
                    <Box className="sign-up--term-condition">
                      <Box className="sign-up--term-condition-label">
                        By Signing up you agree to our{' '}
                        <MUILink
                          className="sign-up--term-condition-url"
                          href={`${WEBSITE_URL}/terms-and-conditions`}>
                          {' '}
                          Terms and Condition{' '}
                        </MUILink>
                        and{' '}
                        <MUILink
                          className="sign-up--term-condition-url"
                          href={`${WEBSITE_URL}/terms-and-conditions#privacy-policy`}>
                          {' '}
                          Privacy Policy{' '}
                        </MUILink>
                      </Box>
                    </Box>
                  }
                />
              </FormGroup>
              {errors?.tc && (
                <FormHelperText className="term-condition-error">
                  Please accept the terms and conditions.
                </FormHelperText>
              )}
            </FormControl>
          </Box>
          <Box className="sign-up-news-letter-wrapper">
            <FormControl component="fieldset" variant="standard">
              <FormGroup>
                <FormControlLabel
                  key="newsLetter"
                  control={
                    <Controller
                      name="newsLetter"
                      control={control}
                      defaultValue={true}
                      render={({ field }) => <Checkbox {...field} checked={field.value} />}
                    />
                  }
                  label={
                    <Box className="sign-up--term-condition">
                      <Box className="sign-up--term-condition-label margin-top--0">
                        I agree to receive{' '}
                        <MUILink
                          className="sign-up--term-condition-url"
                          href={`${WEBSITE_URL}/terms-and-conditions#data-privacy`}>
                          Promotional Communications
                        </MUILink>
                      </Box>
                    </Box>
                  }
                />
              </FormGroup>
              {/* {errors?.tc && (
                <FormHelperText className="term-condition-error">
                  Please accept the terms and conditions.
                </FormHelperText>
              )} */}
            </FormControl>
          </Box>
          <Box className="registration-captcha-wrapper">
            <ReCAPTCHA
              className="re-captcha"
              ref={recaptchaRef}
              // we need to update this sitekey after genrate
              sitekey={sitekey}
              onChange={() => {
                setValue('recaptcha', 'reCAPTCHA');
                clearErrors('recaptcha');
              }}
              onExpired={() => handleExpiredCaptcha(setValue)}
              hl="en"
            />
            {errors.recaptcha && (
              <FormHelperText className="term-condition-error">
                Please complete the CAPTCHA.
              </FormHelperText>
            )}
          </Box>
          <Box className="basic-btn-container">
            <Box className="submit-btn-wrapper">
              <Button
                type="submit"
                variant="contained"
                className="submit-btn"
                size="medium"
                disabled={!role || userRegisterData.loading}>
                Sign up
              </Button>
            </Box>
          </Box>
          <Box className="already-account-wrapper">
            Already have an account?{' '}
            <Link to="/login" className="login-url">
              Log In
            </Link>
          </Box>
        </Box>
      </form>
    </Fragment>
  );
};

export default BasicForm;
